import React from 'react';

import ContinueButton from 'nav/full-screen/ContinueButton';

const Illustration = ({fileName}: {fileName: string}): JSX.Element => (
  <div style={{textAlign: 'center'}}>
    <img src={`/static/img/landing/bioregistry/${fileName}`} className="welcomeScreen-img" />
  </div>
);

interface WelcomeScreenProps {
  isLoading: boolean;
  onContinue: () => void;
}

export default function WelcomeScreen({isLoading, onContinue}: WelcomeScreenProps): JSX.Element {
  return (
    <div className="registryActivation-main">
      <div>
        <h1 className="registryActivation-header">
          Welcome to the Registry, your lab's Inventory Management System
        </h1>
        <div className="welcomeScreen-paragraph registryActivation-container-content">
          <span>
            <h2 className="registryActivation-container-subheader">All Your Samples in One Place</h2>
            <p>
              Consolidate disparate databases into one centralized platform. Customized for your lab to
              include info about box location, lineages, and other fields.
            </p>
          </span>
          <span>
            <Illustration fileName="one-place.png" />
          </span>
        </div>
        <div className="welcomeScreen-paragraph registryActivation-container-content">
          <span>
            <h2 className="registryActivation-container-subheader">
              Standardize Data Capture Across the Lab
            </h2>
            <p>
              Establish standard naming schemes to make searching, tracking, and sharing data streamlined.
            </p>
          </span>
          <span>
            <Illustration fileName="data-capture.png" />
          </span>
        </div>
        <div className="welcomeScreen-paragraph registryActivation-container-content">
          <span>
            <h2 className="registryActivation-container-subheader">Gain Transparency into your Research</h2>
            <div>
              <p>
                Reference samples in your notebook in real time. Never miss important details again, so you
                can answer questions such as:
              </p>
              <ul>
                <li>Which plasmid expresses GFP?</li>
                <li>What is the lineage of your strain?</li>
                <li>Where is an oligo created?</li>
                <li>Who created this cell line?</li>
              </ul>
            </div>
          </span>
          <span>
            <Illustration fileName="transparency.png" />
          </span>
        </div>
      </div>
      <div className="pull-right">
        {isLoading ? (
          <ContinueButton disabled={true} text="Loading..." primary={true} />
        ) : (
          <ContinueButton text="Set up your Registry" onClick={onContinue} primary={true} />
        )}
      </div>
    </div>
  );
}
